import { languages, roles } from '../config/AppConfig';
import i18n from '../i18n';
import { parseISO, addMilliseconds, subMilliseconds, format as formatDate } from 'date-fns';
import { getTimezoneOffset, utcToZonedTime } from 'date-fns-tz';

export const setLanguage = (languageId) => {
  let languageCode = 'en';
  const selectedLanguage = languages.find((lang) => lang.id === languageId);
  if (selectedLanguage) {
    languageCode = selectedLanguage.code;
  }
  i18n.changeLanguage(languageCode);
};

export const getLanguageId = () => {
  const languageCode = i18n.language;
  let languageId = 1;
  const selectedLanguage = languages.find((lang) => lang.code === languageCode);
  if (selectedLanguage) {
    languageId = selectedLanguage.id;
  }
  return languageId;
};

export const getCountryPhoneCode = (languageId) => {
  let languageCode = 'en';
  const selectedLanguage = languages.find((lang) => lang.id === languageId);
  if (selectedLanguage) {
    languageCode = selectedLanguage.phoneCode ? selectedLanguage.phoneCode : selectedLanguage.code;
  }
  return languageCode;
};

export const validateField = (type, expression) => {
  if (type === 'email') {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(expression);
  }
  if (type === 'phone') {
    const reg = /^\+{1}\d{4,}$/;
    return reg.test(expression);
  }
  if (type === 'number') {
    const reg = /^(\s*|-?\d+)$/;
    return reg.test(expression);
  }
};

export const checkRole = (role, roleTitle) => {
  if (role) {
    return role.find(({ authorityId }) => authorityId === roles[roleTitle]['id']) !== undefined;
  }
};

export const checkPermission = (customers, customerIdSub, settingType) => {
  let hasPermission = false;
  let customerSettings = [];
  const currentCustomer = customers.find((customer) => customer.customerIdSub === customerIdSub);
  if (currentCustomer && currentCustomer.customerSettings) {
    customerSettings = currentCustomer.customerSettings;
    if (customerSettings.length > 0) {
      const specificSetting = customerSettings.find((setting) => setting.customerSettingType === settingType);
      if (specificSetting) {
        hasPermission = specificSetting.customerSettingValue;
      }
    }
  }
  return hasPermission;
};

export const generateId = () => {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  );
};

export const convertTimeToDate = (time) => {
  return `2022-02-20T${time ? time : '00:00:00'}`;
};

export const formatDateTime = (dateInput) => {
  return formatDate(new Date(dateInput), 'd.M.yyyy HH:mm:ss');
};

export const getTimestamp = (dateInput) => {
  const timestamp = new Date(dateInput).getTime();
  return timestamp;
};

/* Note: these hacks are necessary because the backend is adding the wrong timeZone.
 ** For an event occuring at 15:00 Finnish time, the backend returns "time": "2021-09-04T15:00:00.000+0000" which is wrong.
 ** You can test this by opening a door, then check the response of getEventReportResponse, from POST /cmanager/v2/third-party/eventlog/filtered/{customerId}
 */

export const hackToSubtractOffset = (dateInput) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = getTimezoneOffset(timeZone, dateInput);
  const convertedDate = subMilliseconds(parseISO(dateInput), offset);
  return convertedDate.toJSON();
};

export const hackToAddOffset = (dateInput) => {
  if(dateInput instanceof Date){
    dateInput=dateInput.toJSON();
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = getTimezoneOffset(timeZone, dateInput);
  const convertedDate = addMilliseconds(parseISO(dateInput), offset);
  return convertedDate.toJSON();
};

export const displayAbsoluteTime = (dateInput) => {
  return utcToZonedTime(dateInput, 'UTC');
};

export const convertUnicode = (str) => {
  return str
    ? str.replace(/&#([0-9]{1,4});/gi, function(match, numStr) {
        var num = parseInt(numStr, 10); // read num as normal number
        return String.fromCharCode(num);
      })
    : str;
};

export const capitalize = (str) => {
  if (!str) {
    return str;
  }
  const lower = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lower.slice(1);
};

export const isTagValid = (tagUid) => {
  // only decimal numbers, hexadecimal numbers (0-9 A-F), minimum 4 characters
  return tagUid.match(/^[a-fA-F0-9]{4,}$/);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'kb', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const haveSameIds = (biggerArray, smallerArray, idName) =>
  biggerArray?.length > 0 &&
  smallerArray?.length > 0 &&
  biggerArray?.every((element1) => smallerArray.findIndex((element2) => element2[idName] === element1[idName]) > -1);
